<template>
  <div></div>
</template>
<script>
import { getWeixinCode } from "network/public";
import { loginByOpenId, saveInfo } from "network/login";
import { userCentresDomain } from "common/const";
export default {
  name: "weixinAuth",
  data() {
    return {
      redirectURL: "",
    };
  },
  computed: {
    openIdUrl() {
      const openIdUrl = this.$route.query.openId;
      return openIdUrl && openIdUrl.length > 0 ? openIdUrl : "";
    },
    // redirectURL(){
    // 	return localStorage.getItem('redirectURL');
    // },
    openIdStorage() {
      const wxOpenId = localStorage.getItem("wxOpenId");
      return wxOpenId && wxOpenId.length > 0 ? wxOpenId : "";
    },
  },
  created() {
    // alert("进入微信授权");
    // 微信环境登录逻辑：
    // ①localStorage中存在openId则直接openId登录,不存在则第②步
    // ②截取url中携带的openId参数，如果存在则直接openId登录，不存在则第③步
    // ③调微信授权接口发起授权(successUrl传当前页面url)，授权失败则跳转登录页，成功则第④步
    // ④截取url中携带的openId参数,如果存在则直接openId登录,登录失败时,当提示"账号不存在"则跳转注册页面，其他错误信息则直接弹窗提示

    // 截取来源页redirectURL并存入localStorage中
    try {
      const redirectURL = this.$route.query.redirectURL;
      if (redirectURL) {
        localStorage.setItem("redirectURL", redirectURL);
      }
      this.redirectURL = localStorage.getItem("redirectURL");

      console.log(redirectURL, "获取到的url");
      // 缓存中有openId或者url中携带openId，则直接微信openId登录
      this.$loading.show("");
      const openIdStorage = this.openIdStorage;
      // || 'oJN3K52FDsCDUqciwvXBqjr_WuqM'
      // alert("缓存openid" + openIdStorage);
      const openIdUrl = this.openIdUrl;
      if (openIdStorage) {
        // alert(1);
        this.loginByOpenIdFun(openIdStorage);
        return false;
      } else if (openIdUrl) {
        // alert(2);
        localStorage.setItem("wxOpenId", openIdUrl);
        this.loginByOpenIdFun(openIdUrl);
        return false;
      }
      // 发起微信授权
      this.getWeixinCodeFun();
    } catch (err) {
      // alert(3);
      console.log(err);
    }
  },
  methods: {
    // 微信openId登录：账号不存在时，跳转注册页
    loginByOpenIdFun(openId) {
      // alert("openId:" + openId);
      // this.$loading.show("");
      // var type = localStorage.getItem("port") || "";
      // // alert(type, "类型");
      // if (type == "grant_type_admin") {
      //   this.$loading.hide();
      // alert(openId + "登录");
      //   this.$router.push("/MaintainAdminLogin");
      //   return;
      // }
      loginByOpenId(openId)
        .then((res) => {
          // alert(JSON.stringify(res) + "登录状态");

          if (res.data && res.data.access_token) {
            saveInfo(res.data, this.redirectURL);
          } else {
            this.$router.push("/login");
            // const msg = res.data.error;
            // alert(res.data.error)
            // if (msg.indexOf("账号不存在") > -1) {
            //   this.$toast.show("请注册账号！", 1500);
            //   this.$router.push("/regist");
            // } else {
            // this.$confirm.show(msg);
            // }
          }
        })
        .catch((err) => {
          // alert("错误信息：" + JSON.stringify(err));
          this.$router.push("/login");
          // const msg = err.data.error;
          // if (msg.indexOf("账号不存在") > -1) {
          //   this.$toast.show("请注册账号！", 1500);
          //   this.$router.push("/regist");
          // } else {
          //   this.$confirm.show(msg);
          // }
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    // 发起微信授权
    getWeixinCodeFun() {
      // alert("发起微信授权");
      getWeixinCode("http://www.hqgy666.cn/weixinAuth")
        .then((res) => {
          // alert(res.data.headers[0].value[0]);
          window.location.href = res.data.headers[0].value[0];
        })
        .catch((err) => {
          this.$router.push("/login");
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
  },
};
</script>
